import React, { Component } from 'react';
import { Navbar, NavbarBrand, Nav, NavbarToggler, Collapse, NavItem, Jumbotron,
    Button, Modal, ModalHeader, ModalBody,
    Form, FormGroup, Input, Label } from 'reactstrap';
import { NavLink,Link } from 'react-router-dom';
import HomeIcon from "@material-ui/icons/Home";
import InfoIcon from "@material-ui/icons/Info";
import RestaurantMenuIcon from "@material-ui/icons/RestaurantMenu";
import FavoriteIcon from "@material-ui/icons/Favorite";
import ContactSupportIcon from "@material-ui/icons/ContactSupport";
import MeetingRoomIcon from "@material-ui/icons/MeetingRoom";

class Header extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isNavOpen: false,
            isModalOpen: false
        };
        this.toggleNav = this.toggleNav.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.handleLogin = this.handleLogin.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
    }

    toggleNav() {
        this.setState({
            isNavOpen: !this.state.isNavOpen
        });
    }

    toggleModal() {
        this.setState({
            isModalOpen: !this.state.isModalOpen
        });
    }

    handleLogin(event) {
        this.toggleModal();
        this.props.loginUser({username: this.username.value, password: this.password.value});
        event.preventDefault();

    }

    handleLogout() {
        this.props.logoutUser();
    }

    render() {
        return (
          <React.Fragment>
            <Navbar dark expand="md" style={{ backgroundColor: "#ff9c71" }}>
              <div className="container">
                <NavbarToggler onClick={this.toggleNav} />
                <NavbarBrand className="mr-auto" href="/">
                  <img
                    src="assets/images/logo.png"
                    height="60"
                    width="75"
                    alt="Belly Side Up"
                  />
                </NavbarBrand>
                <Collapse isOpen={this.state.isNavOpen} navbar>
                  <Nav navbar>
                    <NavItem style={{ color: "#ea907a" }}>
                      <NavLink className="nav-link" to="/home">
                        <span style={{ color: "#900c3f" }}>Home</span>
                        <HomeIcon color="secondary" />
                      </NavLink>
                    </NavItem>
                    <NavItem style={{ color: "#ea907a" }}>
                      <NavLink className="nav-link" to="/aboutus">
                        <span style={{ color: "#900c3f" }}>About us</span>
                        <InfoIcon color="secondary"></InfoIcon>
                      </NavLink>
                    </NavItem>
                    <NavItem style={{ color: "#ea907a" }}>
                      <NavLink className="nav-link" to="/menu">
                        <span style={{ color: "#900c3f" }}>Menu</span>
                        <RestaurantMenuIcon color="secondary"></RestaurantMenuIcon>
                      </NavLink>
                    </NavItem>
                    <NavItem style={{ color: "#ea907a" }}>
                      <NavLink className="nav-link" to="/favorites">
                        <span style={{ color: "#900c3f" }}>My favorites</span>
                        <FavoriteIcon color="secondary"></FavoriteIcon>
                      </NavLink>
                    </NavItem>
                    <NavItem style={{ color: "#ea907a" }}>
                      <NavLink className="nav-link" to="/contactus">
                        <span style={{ color: "#900c3f" }}>Contact us</span>
                        <ContactSupportIcon color="secondary"></ContactSupportIcon>
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Nav className="ml-auto" navbar>
                    <NavItem style={{ color: "#ea907a" }}>
                      {!this.props.auth.isAuthenticated ? (
                        <Button outline onClick={this.toggleModal}>
                          <Link to="/home">Login</Link>{" "}
                          <MeetingRoomIcon color="secondary"></MeetingRoomIcon>
                          {this.props.auth.isFetching ? (
                            <span className="fa fa-spinner fa-pulse fa-fw"></span>
                          ) : null}
                        </Button>
                      ) : (
                        <div>
                          <div
                            className="navbar-text mr-3"
                            style={{
                              color: "#900c3f",
                            }}
                          >
                            {this.props.auth.user.username}
                          </div>
                          <Button outline onClick={this.handleLogout}>
                            Logout{" "}
                            <MeetingRoomIcon color="secondary"></MeetingRoomIcon>
                            {this.props.auth.isFetching ? (
                              <span className="fa fa-spinner fa-pulse fa-fw"></span>
                            ) : null}
                          </Button>
                        </div>
                      )}
                    </NavItem>
                  </Nav>
                </Collapse>
              </div>
            </Navbar>
            <Jumbotron style={{ backgroundColor: "#ff847c" }}>
              <div className="container">
                <div className="row row-header">
                  <div className="col-12 col-sm-6">
                    <h1>Belly Side Up</h1>
                    <p>
                      A Haven of feel-good food and the harbour for all those
                      satisfactory burps, this cafe/restaurant is the place that
                      will bring a smile on your faces and your pockets. We
                      offer you a wide range of dishes to indulge in, be it a
                      steamy cup of hot chocolate to enjoy with your friends on
                      a rainy day or a trip through the tingling flavours of the
                      pizza bursting with cheese. Take a step towards our humble
                      establishment to lose yourself to your cravings and dive
                      into our food until you're Belly Side Up!
                    </p>
                  </div>
                </div>
              </div>
            </Jumbotron>
            <Modal isOpen={this.state.isModalOpen} toggle={this.toggleModal}>
              <ModalHeader toggle={this.toggleModal}>Login</ModalHeader>
              <ModalBody>
                <Form onSubmit={this.handleLogin}>
                  <FormGroup>
                    <Label htmlFor="username">Username</Label>
                    <Input
                      type="text"
                      id="username"
                      name="username"
                      innerRef={(input) => (this.username = input)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="password">Password</Label>
                    <Input
                      type="password"
                      id="password"
                      name="password"
                      innerRef={(input) => (this.password = input)}
                    />
                  </FormGroup>
                  <FormGroup check>
                    <Label check>
                      <Input
                        type="checkbox"
                        name="remember"
                        innerRef={(input) => (this.remember = input)}
                      />
                      Remember me
                    </Label>
                  </FormGroup>
                  <Button type="submit" value="submit" color="primary">
                    Login
                  </Button>
                </Form>
              </ModalBody>
            </Modal>
          </React.Fragment>
        );
    }
}

export default Header;